<template>
  <div
    draggable="true"
    data-cy="contract-field"
    class="draggable flex cursor-grab items-center divide-x rounded-sm bg-white shadow-main active:cursor-grabbing"
  >
    <div class="p-4">
      <icon-base
        :icon="IconDragHandle"
        width="6"
        height="10"
        viewBox="0 0 12 20"
      />
    </div>
    <span class="p-4">{{ field.name }}</span>
  </div>
</template>

<script setup lang="ts">
import IconDragHandle from "@/components/icons/IconDragHandle.vue";

import type { ContractTemplateField } from "@/models/options";

defineProps<{
  field: ContractTemplateField;
}>();
</script>
